import { useCallback } from 'react';
import useTypePlayList from './useTypePlayList';
import { PlaylistEnum } from '../enum/PlaylistEnum';

const useHandleRedirectByParams = () => {
    const { id } = useTypePlayList();

    const handleRedirect = useCallback(() => {
        const params = id.trim().toUpperCase();

        if (params === PlaylistEnum.SEMINARIO) {
            return '/alfabetizacao-360';
        } else if (params === PlaylistEnum.PROMOVER_ALFABETIZACAO) {
            return '/alfabetizacao-360';
        } else if (params === PlaylistEnum.NOT404) {
            return '/playlist-videos/not404';
        }
        return '/playlist-videos';
    }, [id]);

    return { handleRedirect };
};

export default useHandleRedirectByParams;
